<template>
	<div :class="optionsToAdd.length ? 'hasOptions' : ''">
		<el-select
			:multiple="true"
			collapse-tags
			style="width: 100%"
			v-model="optionsToAdd"
			placeholder="Select fields to add"
		>
			<el-option
				@click.native="collectionOptionClicked(property)"
				v-for="(property, i) in proxyOptions"
				:key="property.name + i"
				:label="property.displayName"
				:value="property.name"
			>
			</el-option>
		</el-select>
		<el-form style="margin-top: 10px" ref="form" label-position="top" label-width="100px" :model="form">
			<span :key="property.name + i" v-for="(property, i) in optionsObject.options">
				<el-form-item
					v-if="showIfSpecified(property)"
					:prop="property.name"
					:label="property.type === 'notice' ? '' : property.displayName"
				>
					<paramsInterfaceElement
						:form="form"
						:rootForm="rootForm"
						:property="property"
						:integrationInterface="integrationInterface"
					/>
				</el-form-item>
			</span>
		</el-form>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	name: "collectionsInterfaceElement",
	computed: {
		...mapGetters(["returnActiveWorkflow"]),
		proxyOptions() {
			return this.optionsObject.options.filter((each) => {
				if (this.determineIfToShowField(each.displayOptions)) {
					return each;
				} else {
					//If any property is hidden or shown as a result of some field changing then reset the options as some might be newly available or no longer available
					this.optionsToAdd = this.optionsToAdd.filter((eachOption) => {
						return eachOption !== each.name;
					});
				}
			});
		},
	},
	components: {
		paramsInterfaceElement: () => import("./paramsInterfaceElement.vue"),
	},
	props: {
		optionsObject: Object,
		integrationInterface: Object,
		form: Object,
		rootForm: Object,
	},
	data() {
		return {
			optionsToAdd: [],
		};
	},
	beforeMount() {
		this.populateFormData();
	},
	methods: {
		collectionOptionClicked(property) {
			//Reset parameter to default value except for nested fixed collections
			if (property.type !== "fixedCollection") {
				this.form[property.name] = property.default;
			}
		},
		populateFormData() {
			this.optionsObject.options.forEach((property) => {
				//Properties need to be set dynamically so they are reactive
				let propertyDefault = property.default;
				if (property.type === "fixedCollection" && Array.isArray(propertyDefault)) {
					//Fixed collections should always be objects
					propertyDefault = {};
				}
				if (!this.form[property.name]) {
					this.$set(this.form, property.name, propertyDefault);
				} else {
					//Automatically display option as it has data
					this.determineIfToDisplayOption(this.form, property);
				}
			});
		},
		determineIfToDisplayOption(form, property) {
			if (typeof form[property.name] === "object") {
				let isArray = Array.isArray(form[property.name]);
				if (isArray) {
					if (form[property.name].length) {
						this.optionsToAdd.push(property.name);
					}
				} else {
					for (let key in form[property.name]) {
						if (form[property.name][key].length) {
							this.determineIfToDisplayOption(form[property.name], property);
						}
					}
				}
			} else {
				this.optionsToAdd.push(property.name);
			}
		},
		showIfSpecified(property) {
			const shouldShow = this.optionsToAdd.find((each) => {
				return each === property.name;
			});
			return shouldShow;
		},
		determineIfToShowField(displayOptions) {
			if (!displayOptions) {
				return true;
			}
			if (displayOptions.show) {
				for (let key in displayOptions.show) {
					let useRootForm = key.charAt(0) === "/" ? true : false;
					let adjustedKey = key;
					if (useRootForm) {
						adjustedKey = adjustedKey.substring(1);
					}
					const correspondingPropertyInData = useRootForm ? this.rootForm[adjustedKey] : this.form[key];
					const listOfPermissableValues = displayOptions.show[key];
					if (!listOfPermissableValues.includes(correspondingPropertyInData)) {
						return false;
					}
				}
			}
			if (displayOptions.hide) {
				for (let [index, [key]] of Object.entries(Object.entries(displayOptions.hide))) {
					let useRootForm = key.charAt(0) === "/" ? true : false;
					let adjustedKey = key;
					if (useRootForm) {
						adjustedKey = adjustedKey.substring(1);
					}
					index = parseInt(index);
					const correspondingPropertyInData = useRootForm ? this.rootForm[adjustedKey] : this.form[key];
					const listOfValuesNotAllowed = displayOptions.hide[key];
					if (correspondingPropertyInData && !listOfValuesNotAllowed.includes(correspondingPropertyInData)) {
						//Return true to display the property if any one of the hide relevant keys is not set to one of its specified properties
						//Display rule has thus failed, thus we show the field as its the inverse of 'hide'
						return true;
					}
					if (Object.entries(Object.entries(displayOptions.hide)).length - 1 === index) {
						if (listOfValuesNotAllowed.includes(correspondingPropertyInData)) {
							//On the last index if the property of the key in data is set to a specified value then all hide keys have some value that means the field should be hidden
							//Display rule has thus passed, thus we hide the field as this is what the hide rule wishes us to do
							return false;
						}
					}
				}
			}
			return true;
		},
	},
};
</script>

<style scoped>
.hasOptions {
	border: 1px dashed #210f3c;
	padding-left: 10px;
	padding-right: 10px;
	padding-top: 10px;
	border-radius: 4px;
}
</style>
